import React from "react";
import { CircularProgress } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStylesForSpinner = makeStyles((theme) => ({
  root: {
    position: "relative",
    color: "red",
  },

  top: {
    color: "#1a90ff",
    animationDuration: "550ms",
    left: 0,
  },
  circle: {
    strokeLinecap: "round",
    background: "red",
    color: "#231F20",
  },
}));

export const UiLoginLoader = (props) => {
  const classes = useStylesForSpinner();

  return (
    <>
      <div className="df-login-full-loader">
        {props.inverted ? (
          <div className="df-inverted">
            <CircularProgress
              variant="indeterminate"
              className={classes.top}
              classes={{
                circle: classes.circle,
              }}
              size={props.loaderSize}
              thickness={props.loaderThickness}
            />
            {props.backdropMessage && (
              <p className="df-login-full-loader__message">
                {props.backdropMessage}
              </p>
            )}
          </div>
        ) : (
          <CircularProgress
            variant="indeterminate"
            className={classes.top}
            classes={{
              circle: classes.circle,
            }}
            size={props.loaderSize}
            thickness={props.loaderThickness}
          />
        )}
      </div>
    </>
  );
};
